<template>
  <div>
    <div class="Archive bg-cover">
      <div id="chapterFilter">
        <span id="chFilterLabel">Select chapter:</span>
        <b-form-select id="chapter-filter" v-model="selected" @change="filterChapter">
          <option v-for="option in options" :key="option.id" :value="option">
            Chapter {{option.chapterNum}} - {{option.title}}
          </option>
        </b-form-select>
      </div> 
      <h1 class="gridHeader">Chapter {{this.selected.chapterNum}}</h1>
      <b-container class="archiveChapter">
        <b-row cols-sm="2" cols-md="4" cols-lg="5" class="archiveThumbs">
          <b-col class="my-1" v-for="(page, pageIndex) in this.imgURLs" :key="pageIndex">
            <a :href="page.route">
              <div class="py-3 px-3 pageLabel">
                {{pageIndex+1}}
              </div>
              <b-img :width="85" :src="page.link"></b-img>
            </a>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { db } from '@/firebase/init'

export default {
  components: {
  },
  data(){
    return{
      lightGalleryIndex: null,
      imgURLs: [],
      links: [],
      selected: null,
      options: [],
      doc_ids: [],
      currChapter: null
    }
  },

  methods: {
    getPagesURLs(chapterid){
      // get urls of all pages in current chapter selected
      // var url = 'http://localhost:8080/#/' // localhost/#/chapternum/pagenum
      var url = window.location.origin + '/#/'
      var currURLs = []
      db.collection('comics')
      .doc('chapter' + chapterid)
      .collection('pages')
      .orderBy("pageNum", "asc")
      .get()
      .then((docs)=>{
        if(docs){
          docs.forEach((doc)=>{
            var currDoc = doc.data()
            currURLs.push({
              pagenum: currDoc.pageNum,
              link: currDoc.link_thumb,
              route: url + 'chapter' + currDoc.chapterNum + '/' + currDoc.pageNum
            })
            // console.log('chapter ' + chapterid + ' page ' + currDoc.pageNum) 
          })
        }
        else{
          throw "No chapter found"
        }
      }).then(()=>{
        this.imgURLs = currURLs
        this.generateLinks(this.imgURLs)
        // console.log(this.links)
      })
    },
    generateLinks(imgURLs){
      // var url = 'http://localhost:8080/#' // localhost/#/chapternum/pagenum
      var url = window.location.origin + '/#/'
      this.links = []
      for(var i = 0; i < imgURLs.length; i++){
        this.links.push(url + 'chapter' + this.selected.chapterNum + '/' + (i + 1) + '/')
      }
    },
    queryChapterCollection(){
      //query the db for all chapters
      db.collection('comics')
      .orderBy("chapterNum", "asc")
      .get()
      .then(docs =>{
        // console.log(docs)
        docs.forEach(doc => {
          //retrieve the chapter num of the document
          var chapterNum = doc.data().chapterNum;
          // console.log("chapnum:")
          // console.log(doc.data().chapterNum)
          //concatenate with chapter
          //var s = "Chapter " + chapterNum;
          var chapterTitle = ''
          if(doc.data().title != null){
            chapterTitle = doc.data().title
          }
          var object = {id: doc.id, chapterNum: chapterNum, title: chapterTitle}
          this.options.push(object);
          this.setSelected(); 
        });
      })
      .catch(err=>{
        throw err;
      })
      .then(()=>{
        this.getPagesURLs(this.currChapter)
      })
    },
    setSelected(){
      //set selected to first chapter retrieved
      // console.log(this.options[0].text + "here");
      this.selected = this.options[0];
      // console.log("Selected changed: " + this.selected);
      this.currChapter = this.parseChapterNum(this.selected.id)
    },
    parseChapterNum(chapterid){
      return parseInt(chapterid.replace('chapter',''))
    },
    filterChapter(){
      this.currChapter = this.parseChapterNum(this.selected.id)
      this.getPagesURLs(this.currChapter)
    // console.log(this.options);
    // console.log(this.imgURLs)
    }
  },
  created(){
    this.queryChapterCollection()
  }
}
</script>

<style>
a{
  color: inherit;
  text-decoration: none;
}

#chapterFilter{
  display: flex;
  color: #ffffff;
}

.Archive{
  margin-right: auto;
  margin-left: auto;
  margin-top: 25px;
  display: inline-block;
  padding: 5%;
	/*justify-content: center;
	align-items: center;*/
  background-image: url('../assets/paper_texture.png');
  background-repeat: round;
  width: 100%;
}

.archiveChapter{
  width: 100%;
  margin-bottom: 20px;
}

.gridHeader{
  color: #FFFFFF;
}

.pageLabel{
  color: #FFFFFF;
}

#chapter-filter > option{
  font-family: KnightsQuest, Avenir, Helvetica, Arial, sans-serif;
}
</style>